import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Breadcrumb, Button, Col, Input, Row } from 'antd'
import '../../css/schedule.scss'
import ExerciseRow from './exercise.row'
import {
  getAllExercises,
  setExercises,
} from '../../store/action/exercise.action'
import _ from 'lodash'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom/cjs/react-router-dom'

import moment from 'moment'
import { getHelp, pages } from '../../tutorials'
const List = (props) => {
  const [add, setAdd] = useState(false)
  const [search, setSearch] = useState(null)
  const location = useLocation()
  const [edit, setEdit] = useState()

  useEffect(() => {
    if (!location.state.exercises) {
      props.getAllExercises(props.customer && props.customer._id)
    } else props.setExercises(location.state.exercises)
    getHelp(pages.EXESCHED)
  }, [])

  var renderExercises = () => {
    var scrolled = false
    return props.exercises.map((exercise, i) => {
      var connect =
        exercise?.nextexerciseid &&
        exercise.nextexerciseid == props.exercises[i + 1]?.exercise._id
      var isSelectedOne =
        props.isSelected && props.selectedExer._id == exercise._id
      var connected =
        !connect &&
        !isSelectedOne &&
        props.exercises[i - 1]?.nextexerciseid == exercise?.exercise._id
      var highlight = search
        ? exercise.exercise.name.toLowerCase().indexOf(search.toLowerCase()) >=
          0
        : false
      var scroll = highlight && !scrolled
      if (scroll) scrolled = scroll
      return (
        <ExerciseRow
          editPage={props.editPage}
          edit={edit}
          setEdit={(b) => setEdit(b)}
          scroll={scroll}
          connect={connect}
          connected={connected}
          exercise={exercise}
          highlight={highlight}
        />
      )
    })
  }

  var handleOnClose = () => setAdd(false)

  var handleSearch = (value) => (value ? setSearch(value) : setSearch(null))

  var mockExer = {
    exercise: { image: '', name: '' },
    regimen: {},
    startdate: 0,
    enddate: 0,
  }

  return (
    <Col className='patientAddContainer'>
      {props.editPage && (
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to='/patient'>Patients</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Exercise</Breadcrumb.Item>
        </Breadcrumb>
      )}
      <Row align='middle' className='headerRow divide scheduleHeaderCont'>
        <Col className='headerText scheduleHeader'>
          EXERCISE SCHEDULE ( {_.upperFirst(props.newPatient?.firstname)}{' '}
          {_.upperFirst(props.newPatient?.lastname)} -{' '}
          <span
            style={{ fontSize: '17px' }}
          >{` Surgery Date: ${moment(props.newPatient?.surgery?.date).format('MM/DD/YYYY')}`}</span>{' '}
          )
        </Col>
        <Col className='scheduleSearchCol' flex={'30%'}>
          <Input.Search
            placeholder={'Search Exercise'}
            allowClear
            onSearch={handleSearch}
          />
        </Col>
      </Row>
      <Row>
        <Col flex={'auto'}>
          <Row hidden={add} className='exerciseRow'>
            <Col flex={'auto'}>
              <Row>
                <Col className='exerciseCol divide' flex={'30%'}>
                  <Row justify='start'>
                    <Button
                      id={'addexe'}
                      className='nextBtn'
                      onClick={() => setAdd(true)}
                    >
                      ADD EXERCISE
                    </Button>
                  </Row>
                </Col>
                <Col className=' divide' flex={'15%'}></Col>
                <Col className='exerciseCol divide' flex={'55%'}>
                  <Row justify='end' gutter={40}>
                    <Col>
                      <Button className='nextBtn' onClick={props.handleBack}>
                        BACK
                      </Button>
                    </Col>
                    <Col>
                      <Button className='nextBtn' onClick={props.handleNext}>
                        {props.editPage ? 'SAVE' : 'NEXT'}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col flex={'24%'}>
              <Row className='colHeader divide' justify='center'>
                EXERCISE
              </Row>
            </Col>
            <Col flex={'33%'}>
              <Row className='colHeader divide' justify='center'>
                CONFIGURATION
              </Row>
            </Col>
            <Col flex={'33%'}>
              <Row className='colHeader divide' justify='space-around'>
                SCHEDULE
              </Row>
            </Col>
            <Col flex={'10%'}>
              <Row className='colHeader divide' justify='space-around'>
                ACTIONS
              </Row>
            </Col>
          </Row>
          {renderExercises()}

          <ExerciseRow
            exercise={mockExer}
            edit={edit}
            setEdit={(b) => setEdit(b)}
            addBit={add}
            hidden={!add}
            onClose={handleOnClose}
          />
        </Col>
      </Row>
      <Row hidden={add} className='exerciseRow'>
        <Col flex={'auto'}>
          <Row>
            <Col className='exerciseCol divide' flex={'30%'}>
              <Row justify='start'>
                <Button className='nextBtn' onClick={() => setAdd(true)}>
                  ADD EXERCISE
                </Button>
              </Row>
            </Col>
            <Col className=' divide' flex={'15%'}></Col>
            <Col className='exerciseCol divide' flex={'55%'}>
              <Row justify='end' gutter={40}>
                <Col>
                  <Button className='nextBtn' onClick={props.handleBack}>
                    BACK
                  </Button>
                </Col>
                <Col>
                  <Button
                    id={'saveexesched'}
                    className='nextBtn'
                    onClick={props.handleNext}
                  >
                    {props.editPage ? 'SAVE' : 'NEXT'}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  )
}

List.propTypes = {
  customer: PropTypes.object,
  editPage: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    newPatient: state.patient.newpatient,
    exercises: state.schedule.exercises,
    selectedExer: state.schedule.selected,
    isSelected: Object.keys(state.schedule.selected).length > 0,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAllExercises: (customerid) => dispatch(getAllExercises(customerid)),
    setExercises: (exercises) => dispatch(setExercises(exercises)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(List)
